import { Img } from "container/Manual/components/content/Image";
import { Paragraph } from "container/Manual/components/content/Paragraph";
import { Li } from "container/Manual/components/list/Li";
import { Ul } from "container/Manual/components/list/Ul";
import { CardSection } from "container/Manual/components/section/CardSection";
import { ListSection } from "container/Manual/components/section/ListSection";

export const CHAR = () => {
  return (
    <CardSection id="CHAR" title="CHAR">
      <Paragraph>지정된 ASCII 값에 대한 문자를 반환합니다.</Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>CHAR(INT)</Paragraph>
        <Ul>
          <Li>
            <b>INT</b>는 반환할 문자의 ASCII 값입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>CHAR(`ASCII`)</Paragraph>
        <Img src="computeChar" />
      </ListSection>
    </CardSection>
  );
};
